import { defineMessages } from 'react-intl';

export default {
  pages: {
    landing: {
      becomeRichBanner: {
        livejasmin: {
          ...defineMessages({
            title: {
              id: 'pages.landing.becomeRichBanner.livejasmin.title',
              defaultMessage: 'Become a <b>millionaire</b>',
            },
            description: {
              id: 'pages.landing.becomeRichBanner.livejasmin.description',
              defaultMessage:
                'With a quarter-century of experience, LiveJasmin was built for your success, offering unmatched traffic, top-tier earnings, and a unique commitment to safety and growth. Countless models have become millionaires on the platform, be the next one!',
            },
            topModels: {
              id: 'pages.landing.becomeRichBanner.livejasmin.topModels',
              defaultMessage: 'Last year’s top {numModels} earnings of LiveJasmin Models:',
            },
          }),
        },
      },
    },
  },
};
